// Persian translations
export const fa = {
  // Navigation
  navigation: {
    dashboard: 'داشبورد',
    inventory: 'موجودی',
    market: 'بازار',
    production: 'تولید',
    brands: 'برندها',
    copyright: 'کپی رایت',
    employees: 'کارکنان',
    machinery: 'ماشین‌آلات',
    productRequests: 'درخواست افزودن محصول',
    cryptoWallet: 'کیف پول',
    gameTitle: 'بازی کارآفرینی'
  },

  // Dashboard
  dashboard: {
    title: 'خوش آمدید به بازی کارآفرینی',
    subtitle: 'شروع سفر اقتصادی خود',
    cashBalance: 'موجودی نقدی',
    playerLevel: 'سطح بازیکن',
    experience: 'تجربه',
    production: 'تولید محصولات',
    productionSubtitle: 'محصولات جدید تولید کنید',
    market: 'بازار',
    marketSubtitle: 'محصولات خود را بفروشید',
    brands: 'برندهای شما',
    brandsSubtitle: 'مدیریت برندهای شخصی',
    copyright: 'کپی رایت',
    copyrightSubtitle: 'محافظت از محصولات',
    employees: 'کارکنان شما',
    employeesSubtitle: 'مدیریت نیروی انسانی',
    machinery: 'ماشین‌آلات',
    machinerySubtitle: 'مدیریت تجهیزات',
    aiRequests: 'درخواست افزودن محصول',
    aiRequestsSubtitle: 'درخواست افزودن محصول جدید به سیستم',
    recentActivity: 'فعالیت‌های اخیر',
    recentActivitySubtitle: 'آخرین اقدامات شما',
    viewAll: 'مشاهده همه',
    produce: 'تولید',
    sell: 'فروش',
    manage: 'مدیریت',
    goldenBrand: 'برند طلایی',
    reputation: 'اعتبار',
    barbariBread: 'نان بربری',
    specialBarbariBread: 'نان بربری مخصوص',
    requests: 'درخواست‌ها',
    ahmadMohammadi: 'احمد محمدی',
    level: 'سطح',
    breadMachine: 'دستگاه تولید نان',
    excellent: 'عالی',
    gameStart: 'شروع بازی',
    accountCreated: 'حساب کاربری شما ایجاد شد',
    reachedLevel1: 'شما به سطح 1 رسیدید',
    now: 'الان'
  },


  // Common
  common: {
    loading: 'در حال بارگذاری...',
    error: 'خطا',
    success: 'موفقیت',
    save: 'ذخیره',
    delete: 'حذف',
    edit: 'ویرایش',
    add: 'اضافه کردن',
    search: 'جستجو',
    filter: 'فیلتر',
    sort: 'مرتب‌سازی',
    date: 'تاریخ',
    time: 'زمان',
    status: 'وضعیت',
    name: 'نام',
    description: 'توضیحات',
    price: 'قیمت',
    quantity: 'تعداد',
    total: 'مجموع',
    yes: 'بله',
    no: 'خیر',
    confirm: 'تایید',
    close: 'بستن',
    back: 'بازگشت',
    next: 'بعدی',
    previous: 'قبلی',
    submit: 'ارسال',
    reset: 'بازنشانی',
    select: 'انتخاب کنید',
    required: 'الزامی',
    optional: 'اختیاری',
    player: 'بازیکن',
    personal: 'شخصی'
  },

  // Auth
  auth: {
    login: 'ورود',
    register: 'ثبت‌نام',
    logout: 'خروج',
    username: 'نام کاربری',
    email: 'ایمیل',
    password: 'رمز عبور',
    confirmPassword: 'تایید رمز عبور',
    forgotPassword: 'فراموشی رمز عبور',
    rememberMe: 'مرا به خاطر بسپار',
    welcomeBack: 'خوش آمدید',
    createAccount: 'ایجاد حساب کاربری',
    alreadyHaveAccount: 'قبلاً حساب کاربری دارید؟',
    dontHaveAccount: 'حساب کاربری ندارید؟'
  },

  // Copyright
  copyright: {
    title: 'مدیریت کپی رایت',
    subtitle: 'درخواست‌های کپی رایت خود را مدیریت کنید',
    selectProduct: 'انتخاب محصول',
    selectBrand: 'انتخاب برند',
    requestMessage: 'پیام درخواست',
    status: 'وضعیت',
    pending: 'در انتظار',
    approved: 'تایید شده',
    rejected: 'رد شده',
    createdAt: 'تاریخ ایجاد',
    reviewedAt: 'تاریخ بررسی',
    adminResponse: 'پاسخ ادمین',
    yourRequests: 'درخواست‌های شما',
    requests: 'درخواست',
    protectProducts: 'با کپی رایت از محصولات خود محافظت کنید',
    noRequests: 'هیچ درخواستی یافت نشد',
    createRequest: 'درخواست کپی رایت جدید',
    createRequestSubtitle: 'درخواست کپی رایت برای محصول خود',
    yourRequestsSubtitle: 'لیست تمام درخواست‌های شما',
    requestMessagePlaceholder: 'توضیحات درخواست کپی رایت خود را وارد کنید',
    createFirstRequest: 'ارسال اولین درخواست',
    benefits: 'مزایای کپی رایت',
    legalProtection: 'محافظت قانونی',
    legalProtectionDescription: 'از محصولات خود در برابر کپی غیرقانونی محافظت کنید',
    additionalRevenue: 'درآمد اضافی',
    additionalRevenueDescription: 'از کسانی که محصول شما را کپی می‌کنند حق امتیاز دریافت کنید',
    brandCredibility: 'اعتبار برند',
    brandCredibilityDescription: 'کپی رایت اعتبار و ارزش برند شما را افزایش می‌دهد',
    legalRight: 'حق قانونی',
    legalRightDescription: 'حق انحصاری استفاده از محصول خود را داشته باشید'
  },

  // Brands
  brands: {
    title: 'مدیریت برندها',
    subtitle: 'برندهای شخصی خود را مدیریت کنید',
    createBrand: 'ایجاد برند جدید',
    createBrandSubtitle: 'برند جدید خود را تعریف کنید',
    brandName: 'نام برند',
    brandNamePlaceholder: 'نام برند خود را وارد کنید',
    brandDescription: 'توضیحات برند',
    brandDescriptionPlaceholder: 'توضیحات برند خود را وارد کنید',
    reputation: 'اعتبار',
    createdAt: 'تاریخ ایجاد',
    yourBrands: 'برندهای شما',
    yourBrandsSubtitle: 'لیست برندهای ایجاد شده',
    brands: 'برند',
    excellent: 'عالی',
    good: 'خوب',
    average: 'متوسط',
    poor: 'ضعیف',
    viewProducts: 'مشاهده محصولات',
    noBrands: 'هیچ برندی یافت نشد',
    createFirstBrand: 'برای شروع، اولین برند خود را ایجاد کنید.',
    brandCreated: 'برند با موفقیت ایجاد شد!',
    brandError: 'خطا در ایجاد برند',
    fillRequiredFields: 'لطفاً نام برند را وارد کنید'
  },

  // Employees
  employees: {
    title: 'مدیریت کارکنان',
    subtitle: 'کارکنان خود را مدیریت کنید',
    yourEmployees: 'کارکنان شما',
    people: 'نفر',
    totalSalary: 'مجموع حقوق',
    production: 'تولید',
    sales: 'فروش',
    management: 'مدیریت',
    general: 'عمومی',
    skillLevel: 'سطح مهارت',
    salary: 'حقوق',
    experience: 'تجربه',
    efficiency: 'بازدهی',
    hiredAt: 'تاریخ استخدام',
    fire: 'اخراج',
    hire: 'استخدام',
    selectEmployee: 'انتخاب کارگر',
    noEmployees: 'هیچ کارگری یافت نشد',
    hireNewEmployee: 'استخدام کارگر جدید',
    hireNewEmployeeSubtitle: 'از بین کارگران موجود انتخاب کنید',
    yourEmployeesSubtitle: 'لیست تمام کارکنان',
    statistics: '📊 آمار کارکنان',
    statisticsSubtitle: 'اطلاعات کلی کارکنان',
    benefits: 'مزایای استخدام کارگر',
    noEmployeesMessage: 'با استخدام کارگران می‌توانید کارایی خود را افزایش دهید',
    hireFirstEmployee: 'استخدام اولین کارگر',
    employeeCount: 'تعداد کارگر',
    averageEfficiency: 'میانگین کارایی',
    productionWorkers: 'کارگر تولید',
    efficiencyBoost: 'افزایش کارایی',
    efficiencyBoostDescription: 'کارگران کارایی تولید و فروش شما را افزایش می‌دهند',
    specialization: 'تخصص‌یابی',
    specializationDescription: 'هر کارگر در زمینه خاصی تخصص دارد',
    experienceGrowth: 'رشد تجربه',
    experienceGrowthDescription: 'کارگران با گذشت زمان تجربه بیشتری کسب می‌کنند',
    moreProfit: 'سود بیشتر',
    moreProfitDescription: 'کارایی بالاتر منجر به سود بیشتر می‌شود'
  },

  // Machinery
  machinery: {
    title: 'فروشگاه ماشین‌آلات',
    subtitle: 'ماشین‌آلات خود را مدیریت کنید',
    yourMachinery: 'ماشین‌آلات شما',
    devices: 'دستگاه',
    allTypes: 'همه انواع',
    production: 'تولید',
    transport: 'حمل و نقل',
    storage: 'انبار',
    yourMachineryList: 'ماشین‌آلات شما',
    yourMachinerySubtitle: 'لیست ماشین‌آلات خریداری شده',
    noMachinery: 'هنوز ماشین‌آلاتی خریداری نکرده‌اید',
    noMachineryMessage: 'با خرید ماشین‌آلات کارایی خود را افزایش دهید',
    efficiency: 'کارایی',
    maintenanceCost: 'هزینه تعمیر',
    condition: 'وضعیت',
    repair: 'تعمیر',
    details: 'جزئیات',
    level: 'سطح',
    requiredLevel: 'سطح مورد نیاز',
    price: 'قیمت',
    insufficientFunds: 'موجودی کافی نیست',
    insufficientLevel: 'سطح کافی نیست',
    buy: 'خرید',
    statistics: '📊 آمار ماشین‌آلات',
    statisticsSubtitle: 'اطلاعات کلی ماشین‌آلات',
    deviceCount: 'تعداد دستگاه',
    totalValue: 'ارزش کل',
    productionDevices: 'دستگاه تولید',
    benefits: 'مزایای ماشین‌آلات',
    benefitsSubtitle: 'چرا باید ماشین‌آلات بخرید؟',
    efficiencyBoost: 'افزایش کارایی',
    efficiencyBoostDescription: 'ماشین‌آلات کارایی تولید و حمل و نقل را افزایش می‌دهند',
    costReduction: 'کاهش هزینه',
    costReductionDescription: 'ماشین‌آلات هزینه تولید و حمل و نقل را کاهش می‌دهند',
    betterQuality: 'کیفیت بهتر',
    betterQualityDescription: 'ماشین‌آلات پیشرفته کیفیت محصولات را بهبود می‌بخشند',
    scalability: 'مقیاس‌پذیری',
    scalabilityDescription: 'با ماشین‌آلات می‌توانید تولید خود را گسترش دهید',
    shop: 'فروشگاه ماشین‌آلات',
    buyNewMachinery: 'ماشین‌آلات جدید خریداری کنید',
    excellent: 'عالی',
    good: 'خوب',
    average: 'متوسط',
    poor: 'ضعیف',
  },

  // Production
  production: {
    title: 'تولید',
    loading: 'در حال بارگذاری...',
    startNewProduction: 'شروع تولید جدید',
    startNewProductionSubtitle: 'محصول جدید تولید کنید',
    selectProduct: 'انتخاب محصول',
    seconds: 'ثانیه',
    productionInfo: 'اطلاعات تولید',
    product: 'محصول',
    price: 'قیمت',
    productionTime: 'زمان تولید',
    requiredLevel: 'سطح مورد نیاز',
    startProduction: 'شروع تولید',
    activeProductions: '🔄 تولیدات فعال',
    activeProductionsSubtitle: 'تولیدات در حال انجام',
    quantity: 'تعداد',
    timeRemaining: 'زمان باقی‌مانده',
    collect: 'جمع‌آوری',
    waiting: 'در انتظار',
    noActiveProductions: 'هیچ تولید فعالی ندارید',
    noActiveProductionsMessage: 'شروع به تولید محصولات کنید!',
    availableProducts: '📋 محصولات موجود',
    availableProductsSubtitle: 'لیست تمام محصولات قابل تولید',
    category: 'دسته‌بندی',
    food: 'غذا',
    electronics: 'الکترونیک',
    materials: 'مواد',
    textiles: 'منسوجات',
    chemicals: 'شیمیایی',
    construction: 'ساخت و ساز'
  },

  // Market
  market: {
    title: 'بازار',
    loading: 'در حال بارگذاری...',
    subtitle: 'محصولات خود را به مغازه‌ها بفروشید',
    demand: 'تقاضا',
    location: 'موقعیت',
    sellableProducts: 'محصولات قابل فروش',
    shop: 'مغازه',
    basePrice: 'قیمت پایه',
    shopInterest: 'علاقه مغازه',
    priceMultiplier: 'ضریب قیمت',
    sell: 'فروش',
    noProducts: 'این مغازه محصولی نمی‌خرد',
    statistics: 'آمار بازار',
    statisticsSubtitle: 'اطلاعات کلی بازار',
    activeShops: 'مغازه فعال',
    averageDemand: 'میانگین تقاضا',
    sellableProductsCount: 'محصول قابل فروش'
  },

  // Inventory
  inventory: {
    title: 'موجودی کالاها',
    subtitle: 'کالاهای تولید شده شما',
    quality: 'کیفیت',
    quantity: 'تعداد',
    sell: 'فروش',
    details: 'جزئیات',
    emptyInventory: 'موجودی خالی است',
    emptyInventoryMessage: 'هنوز کالایی در موجودی ندارید. شروع به تولید کنید!',
    startProduction: 'شروع تولید'
  },

  // Product Requests
  productRequests: {
    title: 'درخواست افزودن محصول',
    subtitle: 'درخواست افزودن محصول جدید به سیستم',
    newRequest: 'درخواست محصول جدید',
    newRequestSubtitle: 'جزئیات محصول جدید خود را وارد کنید',
    productName: 'نام محصول',
    productNamePlaceholder: 'مثلاً: نان بربری مخصوص',
    category: 'دسته‌بندی',
    selectCategory: 'انتخاب دسته‌بندی',
    targetPrice: 'قیمت هدف',
    targetPricePlaceholder: 'قیمت پیشنهادی محصول',
    description: 'توضیحات',
    descriptionPlaceholder: 'توضیحات کامل محصول',
    requiredMaterials: 'مواد اولیه مورد نیاز',
    requiredMachinery: 'ماشین‌آلات مورد نیاز',
    productionProcess: 'فرآیند تولید',
    productionProcessPlaceholder: 'مراحل تولید محصول به ترتیب',
    estimatedProductionTime: 'زمان تولید تخمینی',
    estimatedProductionTimePlaceholder: 'زمان مورد نیاز برای تولید (دقیقه)',
    submitRequest: 'ارسال درخواست',
    fillRequiredFields: 'لطفاً تمام فیلدهای الزامی را پر کنید',
    addAtLeastOneMaterial: 'لطفاً حداقل یک ماده اولیه اضافه کنید',
    addAtLeastOneMachinery: 'لطفاً حداقل یک ماشین‌آلات اضافه کنید',
    requestSubmitted: 'درخواست شما با موفقیت ارسال شد!',
    submitError: 'خطا در ارسال درخواست',
    yourRequests: 'درخواست‌های شما',
    yourRequestsSubtitle: 'لیست درخواست‌های ارسال شده',
    totalRequests: 'کل درخواست‌ها',
    approvedRequests: 'درخواست‌های تایید شده',
    pending: 'در انتظار',
    underReview: 'در حال بررسی',
    approved: 'تایید شده',
    rejected: 'رد شده',
    createdAt: 'تاریخ ایجاد',
    reviewedAt: 'تاریخ بررسی',
    adminNotes: 'یادداشت ادمین',
    minutes: 'دقیقه',
    noRequests: 'هیچ درخواستی یافت نشد',
    selectExistingMaterial: 'انتخاب ماده موجود',
    selectMaterial: 'انتخاب ماده',
    materialName: 'نام ماده',
    materialNamePlaceholder: 'نام ماده اولیه',
    quantity: 'تعداد',
    unit: 'واحد',
    unitPlaceholder: 'کیلوگرم، لیتر، عدد',
    addMaterial: 'افزودن ماده',
    selectExistingMachinery: 'انتخاب ماشین موجود',
    selectMachinery: 'انتخاب ماشین',
    machineryName: 'نام ماشین',
    machineryNamePlaceholder: 'نام ماشین‌آلات',
    addMachinery: 'افزودن ماشین',
    new: 'جدید',
    food: 'مواد غذایی',
    electronics: 'الکترونیک',
    materials: 'مواد اولیه',
    textiles: 'پارچه و پوشاک',
    chemicals: 'مواد شیمیایی',
    construction: 'ساخت و ساز'
  },

  // Crypto Wallet
  crypto: {
    title: 'سیستم ارز دیجیتال',
    subtitle: 'مدیریت کیف پول و توکن‌های شخصی',
    wallets: 'کیف پول‌ها',
    tokens: 'توکن‌ها',
    transactions: 'معاملات',
    staking: 'استیکینگ',
    createWallet: 'ایجاد کیف پول',
    createToken: 'ایجاد توکن',
    yourWallets: 'کیف پول‌های شما',
    walletsSubtitle: 'لیست کیف پول‌های شخصی',
    yourTokens: 'توکن‌های شما',
    tokensSubtitle: 'لیست توکن‌های ایجاد شده',
    yourTransactions: 'معاملات شما',
    transactionsSubtitle: 'تاریخچه معاملات',
    stakingPools: 'استخرهای استیکینگ',
    stakingSubtitle: 'استیکینگ توکن‌ها برای کسب سود',
    noWallets: 'کیف پولی ایجاد نشده است',
    noWalletsMessage: 'برای شروع، یک کیف پول جدید ایجاد کنید.',
    noTokens: 'توکنی ایجاد نشده است',
    noTokensMessage: 'برای شروع، یک توکن جدید ایجاد کنید.',
    noTransactions: 'هیچ معامله‌ای یافت نشد',
    noTransactionsMessage: 'هنوز معامله‌ای انجام نداده‌اید.',
    walletName: 'نام کیف پول',
    walletNamePlaceholder: 'نام کیف پول خود را وارد کنید',
    tokenName: 'نام توکن',
    tokenNamePlaceholder: 'نام توکن خود را وارد کنید',
    tokenSymbol: 'نماد توکن',
    tokenSymbolPlaceholder: 'مثلاً: BTC, ETH',
    totalSupply: 'تعداد کل',
    totalSupplyPlaceholder: 'تعداد کل توکن‌ها',
    walletCreated: 'کیف پول با موفقیت ایجاد شد!',
    tokenCreated: 'توکن با موفقیت ایجاد شد!',
    walletError: 'خطا در ایجاد کیف پول',
    tokenError: 'خطا در ایجاد توکن',
    balance: 'موجودی',
    address: 'آدرس',
    symbol: 'نماد',
    supply: 'تعداد کل',
    price: 'قیمت',
    marketCap: 'ارزش بازار',
    volume: 'حجم معاملات',
    change24h: 'تغییر 24 ساعت',
    buy: 'خرید',
    sell: 'فروش',
    transfer: 'انتقال',
    stake: 'استیک',
    unstake: 'برداشت از استیک',
    amount: 'مقدار',
    amountPlaceholder: 'مقدار را وارد کنید',
    recipient: 'دریافت‌کننده',
    recipientPlaceholder: 'آدرس دریافت‌کننده',
    stakeAmount: 'مقدار استیک',
    stakeAmountPlaceholder: 'مقدار توکن برای استیک',
    stakePeriod: 'دوره استیک',
    stakePeriodPlaceholder: 'روز',
    apy: 'سود سالانه',
    totalStaked: 'کل استیک شده',
    yourStake: 'استیک شما',
    rewards: 'پاداش‌ها',
    claimRewards: 'دریافت پاداش',
    walletBalance: 'موجودی کیف پول',
    totalValue: 'ارزش کل',
    portfolio: 'پرتفوی',
    portfolioSubtitle: 'نمای کلی سرمایه‌گذاری شما',
    fillRequiredFields: 'لطفاً تمام فیلدهای الزامی را پر کنید',
    createWalletSubtitle: 'کیف پول جدید خود را ایجاد کنید',
    createTokenSubtitle: 'توکن جدید خود را ایجاد کنید',
    transferSubtitle: 'انتقال توکن به کیف پول دیگر',
    selectToken: 'انتخاب توکن',
    tokenDescription: 'توضیحات توکن',
    tokenDescriptionPlaceholder: 'توضیحات توکن خود را وارد کنید',
    initialPrice: 'قیمت اولیه',
    initialPricePlaceholder: 'قیمت اولیه توکن',
    tokenLogoUrl: 'آدرس لوگو توکن',
    tokenLogoUrlPlaceholder: 'آدرس تصویر لوگو توکن',
    viewDetails: 'مشاهده جزئیات',
    selectWalletFirst: 'ابتدا یک کیف پول انتخاب کنید',
    stakingComingSoon: 'استیکینگ به زودی',
    stakingDescription: 'قابلیت استیکینگ توکن‌ها به زودی اضافه خواهد شد',
    transferSuccess: 'انتقال با موفقیت انجام شد!',
    transferError: 'خطا در انتقال'
  }
}